import React from 'react';
import { CLabel, CSelect } from '@coreui/react';

interface IItemsPerPageProps {
  itemsPerPage: number;
  onChange: (page: number) => void;
  values?: number[],
}

export const ItemsPerPage: React.FunctionComponent<IItemsPerPageProps> = ({
  itemsPerPage, onChange, values = [5, 10, 20, 50],
}) => {
  const handleChange = (e: any): void => {
    onChange && onChange(Number(e.target.value))
  };
  return (
    <div className="form-inline justify-content-sm-start">
      <CLabel className="mr-2">Show</CLabel>
      <CSelect
        name="itemsPerPage"
        className="form-control"
        onChange={handleChange}
        value={itemsPerPage}
      >
        {values.map((number, key) => (
          <option value={number} key={key}>
            {number}
          </option>
        ))}
      </CSelect>
      <CLabel className="ml-2">entries</CLabel>
    </div>
  );
};
